export interface EventBus<T> {
  on(listener: (payload: T) => void): () => void;
  emit(payload: T): void;
}

export function createEventBus<T>(): EventBus<T> {
  const listeners = new Set<(payload: T) => void>();
  return {
    on(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    emit(payload) {
      listeners.forEach(fn => {
        try {
          fn(payload);
        } catch (e) {
          console.error('[Galletas4all] event listener threw:', e);
        }
      });
    },
  };
}
